import { render, staticRenderFns } from "./DepositSummary.vue?vue&type=template&id=33922340&scoped=true"
import script from "./DepositSummary.vue?vue&type=script&lang=js"
export * from "./DepositSummary.vue?vue&type=script&lang=js"
import style0 from "./DepositSummary.vue?vue&type=style&index=0&id=33922340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33922340",
  null
  
)

export default component.exports